import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// AUDIT APIS (FormData-based)
// Controller: Auditcon.php
// ================================

// 1) Get Audit Stats
export async function getAuditStats(admin_id) {
    try {
        const fd = new FormData();
        fd.append("admin_id", admin_id);

        const res = await axios.post(`${apiBaseUrl}auditcon/get_audit_stats`, fd, {
            headers: { "Content-Type": "multipart/form-data" },
        });

        return res.data;
    } catch (err) {
        return { status: false, type: "danger", success: "Request Failed" };
    }
}

// 2) Get Audit Logs
export async function getAuditLogs(payload) {
    try {
        const fd = new FormData();
        fd.append("admin_id", payload.admin_id || "");
        fd.append("page_no", payload.page_no ?? 0);
        fd.append("keyword", payload.keyword || "");
        fd.append("module", payload.module || "");
        fd.append("action", payload.action || "");
        fd.append("sortBy", payload.sortBy || "NEWEST");

        const res = await axios.post(`${apiBaseUrl}auditcon/get_audit_logs`, fd, {
            headers: { "Content-Type": "multipart/form-data" },
        });

        return res.data;
    } catch (err) {
        return { status: false, type: "danger", success: "Request Failed" };
    }
}

// 3) Get Audit Log By ID
export async function getAuditLogById(payload) {
    try {
        const fd = new FormData();
        fd.append("admin_id", payload.admin_id || "");
        fd.append("ulog_id", payload.ulog_id || "");

        const res = await axios.post(`${apiBaseUrl}auditcon/get_audit_log_by_id`, fd, {
            headers: { "Content-Type": "multipart/form-data" },
        });

        return res.data;
    } catch (err) {
        return { status: false, type: "danger", success: "Request Failed" };
    }
}

export async function exportAuditLogsXl(payload) {
    try {
        const fd = new FormData();
        fd.append("admin_id", payload.admin_id || "");
        fd.append("keyword", payload.keyword || "");
        fd.append("from_date", payload.from_date || ""); // YYYY-MM-DD
        fd.append("to_date", payload.to_date || "");     // YYYY-MM-DD
        fd.append("module", payload.module || "");
        fd.append("action", payload.action || "");
        fd.append("employee", payload.employee || "");
        fd.append("status", payload.status || "");
        fd.append("sortBy", payload.sortBy || "NEWEST");

        const res = await axios.post(`${apiBaseUrl}auditcon/export_logs_xl`, fd, {
            responseType: "blob", // ✅ important for file download
            headers: { "Content-Type": "multipart/form-data" },
        });

        // ✅ download file
        const blob = new Blob([res.data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;

        a.download = `audit_logs_${new Date().toISOString().slice(0, 19).replace(/[:T]/g, "_")}.csv`;

        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(url);

        return { status: true, type: "success", success: "Export started" };
    } catch (err) {
        return { status: false, type: "danger", success: "Request Failed" };
    }
}

